import {MainRequest} from 'Services/common';

const UrlMap = {
    list: '/aichat/dataset',
    detail: '/aichat/dataset/get',
    edit: '/aichat/dataset/save',
    remove: '/aichat/dataset/del',
};

export namespace DataSet {
    export type QueryForm = {
        ragflowConfigId?: string; //RAGFlow配置ID
    };

    interface Schema {
        code: string; //        数据集编码，唯一标识
        name: string; //        数据集名称
        description: string; //        数据集描述
        externalId: string; //        RAGFlow中的数据集ID
        config: object; //        数据集配置（JSON格式）
        status: boolean; //        状态：0-禁用，1-启用
    }

    export interface List extends Schema {
        id: string;
    }

    export interface Detail extends Schema {
        id: string;
    }

    export interface Form extends Schema {
        id?: string;
    }

    export type QueryList = QueryForm;
}

export class DataSet {
    static async list(params: DataSet.QueryList) {
        return await MainRequest.get<SuccessData<DataSet.List[]>>(UrlMap.list, {
            params,
        })
            .then(res => res.data.data)
            .then(res => {
                return {
                    total: res?.length,
                    data: res,
                };
            });
    }

    static async detail(id: string) {
        return MainRequest.get<SuccessData<DataSet.Detail>>(
            `${UrlMap.detail}/${id}`,
        ).then(res => res.data.data);
    }

    static async save(data: DataSet.Form) {
        return MainRequest.post(UrlMap.edit, data);
    }

    static async remove(id: string) {
        return MainRequest.get(`${UrlMap.remove}/${id}`);
    }
}
